import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Typography, Grid, Container } from "@mui/material";
import { useTranslation } from "react-i18next";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import FarmCard from "../../components/Famer/FamersDetailsCards";
import MyFarmIcon from "../../assets/Icon/MyFarmsIcon.png";
import CustomButton from "../../components/Custom/CustomButton";
import LoaderContainer from "../../components/LoaderContainer";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import ConfirmationPopup from "../../components/Popup/GenericPopup";
import { useAlert } from "../../components/Alert";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex !important",
    flexDirection: "column !important",
    justifyContent: "space-between !important",
  },

  cropContainer: {
    overflowY: "auto",
    maxHeight: "calc(115vh - 300px)",
    textAlign: "center",
    height: "700px",
  },
  addButtonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  farmIcon: {
    width: "127px",
    height: "127px",
    marginBottom: "10px",
  },
}));

const CropCards = ({ crops, t, handleEditClick, handleDeleteClick }) => {
  return (
    <div>
      <Grid container spacing={1}>
        {crops.map((farmland) => (
          <Grid item xs={12} key={farmland.id}>
            <FarmCard
              farm={farmland}
              t={t}
              onEdit={handleEditClick}
              onDelete={handleDeleteClick}
            />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

const Farms = () => {
  const classes = useStyles();
  const [crops, setCrops] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedFarmId, setSelectedFarmId] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const { showAlert } = useAlert();

  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    try {
      const result = await api.get(`/farmer/farms/`);
      setCrops(result.data);
      setLoading(false);
    } catch (err) {
      alert("Error - " + err.response.data.non_field_errors[0]);
      setLoading(false);
    }
  };

  const handleAddNewFarm = () => {
    window.location.href = "/farmer/create-farm";
  };
  const handleEditClick = (farmId) => {
    navigate(`/farmer/create-farm/?farmId=${farmId}`);
  };

  const handleDeleteClick = (farmId) => {
    setSelectedFarmId(farmId);
    setDeleteConfirmationOpen(true);
  };

  const handleConfirmDelete = () => {
    api
      .delete(`/farmer/farms/${selectedFarmId}/`)
      .then((response) => {
        console.log("Farm deleted successfully", response);
        showAlert("success", "Deleted Successfully");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error deleting farm:", error);
        showAlert("error", "Some issue in deleting the Farm");
      });
  };
  return (
    <>
      <Helmet>
        <title>My Farms - Farmapp</title>
      </Helmet>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          className={classes.container}
          sx={{ height: crops.length === 0 ? "58vh" : "94vh" }}
        >
          {crops.length !== 0 && (
            <Typography
              variant="h5"
              sx={{
                mb: 2,
                fontSize: "30px",
                fontWeight: 700,
                marginTop: "10px",
              }}
            >
              {t("My Farms")}
            </Typography>
          )}
          <CustomButton onClick={handleAddNewFarm}>
            {t("Add New Farm")}
          </CustomButton>
          <div className={classes.cropContainer}>
            <CropCards
              crops={crops}
              t={t}
              handleEditClick={handleEditClick}
              handleDeleteClick={handleDeleteClick}
            />
          </div>
          <div className={classes.addButtonContainer}>
            {crops.length === 0 && (
              <div style={{ marginBottom: "30px" }}>
                <img
                  src={MyFarmIcon}
                  alt="My Crops Icon"
                  className={classes.farmIcon}
                />
              </div>
            )}
            {crops.length === 0 && (
              <Typography
                variant="subtitle1"
                sx={{ mb: 2, textAlign: "center" }}
              >
                {t("Your Farms will be shown here once you add them.")}
              </Typography>
            )}
          </div>
        </Container>
      </LoaderContainer>
      <ConfirmationPopup
        open={deleteConfirmationOpen}
        handleClose={() => setDeleteConfirmationOpen(false)}
        handleConfirm={handleConfirmDelete}
        title="Confirm Delete"
        message="Are you sure you want to delete this farm?"
        confirmButtonText="Delete"
        cancelButtonText="Cancel"
      />
    </>
  );
};

export default Farms;
